/* MD · PDP simple product — variant selection + add to cart + open slide cart */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.mdSimpleInit === '1') return;
    root.dataset.mdSimpleInit = '1';

    const cfgEl = root.querySelector('script[data-md-simple-config]');
    if (!cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }

    const variants = cfg.variants || [];
    const options = cfg.options || [];
    let currentVariantId = cfg.default_variant_id;
    const selectedOpts = {};
    /* Initialize selectedOpts from the DEFAULT variant (selected_or_first_available_variant),
       NOT from option.selected_value. They can diverge when the first variant is sold out. */
    const defaultV = variants.find((vv) => vv.id === cfg.default_variant_id);
    options.forEach((o) => {
      let val = o.selected_value;
      if (defaultV) {
        if (o.position === 1 && defaultV.option1 != null) val = defaultV.option1;
        else if (o.position === 2 && defaultV.option2 != null) val = defaultV.option2;
        else if (o.position === 3 && defaultV.option3 != null) val = defaultV.option3;
      }
      /* Some Liquid serializations return value objects {name, swatch} — normalize to string */
      if (val && typeof val === 'object' && 'name' in val) val = val.name;
      selectedOpts[o.position] = val;
    });

    /* Helper: find variant matching all currently selected options */
    function findVariant() {
      const match = variants.find((v) => {
        return options.every((o) => {
          const sel = selectedOpts[o.position];
          if (o.position === 1) return v.option1 === sel;
          if (o.position === 2) return v.option2 === sel;
          if (o.position === 3) return v.option3 === sel;
          return true;
        });
      });
      /* Fallback: default variant (so initial CTAs stay enabled even if option name doesn't match) */
      return match || variants.find((v) => v.id === cfg.default_variant_id);
    }

    /* Find which option index is Color (case-insensitive) */
    const colorOptionPos = (function () {
      for (const o of options) {
        if ((o.name || '').toLowerCase().includes('color')) return o.position;
      }
      return null;
    })();

    /* Update visible label "Color: Marfil" (in swatch row AND in product card) */
    function updateVisibleValue(position, value) {
      const label = root.querySelector(`[data-md-simple-current-${position}]`);
      if (label) label.textContent = value;
      if (colorOptionPos && position === colorOptionPos) {
        const cardLabel = root.querySelector('[data-md-simple-card-color]');
        if (cardLabel) cardLabel.textContent = value;
      }
    }

    /* Swap the small thumbnail image to the variant's featured_image */
    const thumbEl = root.querySelector('[data-md-simple-thumb]');
    function updateMediaForVariant(v) {
      if (!v || !thumbEl) return;
      const img = v.featured_image;
      if (!img || !img.src) return;
      /* featured_image.src in Liquid serialization comes WITHOUT a protocol (//cdn...) */
      let base = img.src;
      if (base.startsWith('//')) base = 'https:' + base;
      else if (base.startsWith('http://')) base = base.replace('http://', 'https://');
      /* Strip any existing width param and build a new srcset */
      const noQuery = base.split('?')[0];
      const v_ts = (base.match(/v=(\d+)/) || [])[1] || '';
      const versionQs = v_ts ? `?v=${v_ts}` : '';
      const buildUrl = (w) => `${noQuery}${versionQs}${versionQs ? '&' : '?'}width=${w}`;
      thumbEl.src = buildUrl(160);
      thumbEl.srcset = `${buildUrl(80)} 80w, ${buildUrl(160)} 160w, ${buildUrl(240)} 240w`;
      thumbEl.alt = (v.name || cfg.product_handle || '');
    }

    /* Update CTAs state (disable if no variant or sold out) */
    function syncCTAs() {
      const v = findVariant();
      currentVariantId = v ? v.id : null;
      const available = !!(v && v.available);
      root.querySelectorAll('[data-md-simple-add], [data-md-simple-buy]').forEach((btn) => {
        btn.disabled = !available;
      });
      updateMediaForVariant(v);
    }

    /* Swatch click: select variant for color option */
    root.querySelectorAll('[data-md-simple-swatch]').forEach((sw) => {
      sw.addEventListener('click', (e) => {
        if (sw.disabled || sw.classList.contains('is-unavailable')) return;
        const pos = parseInt(sw.dataset.optionPosition, 10);
        const val = sw.dataset.value;
        if (!pos || !val) return;
        /* deselect siblings */
        root.querySelectorAll(`[data-md-simple-swatch][data-option-position="${pos}"]`).forEach((s) => {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('is-selected');
        sw.setAttribute('aria-checked', 'true');
        selectedOpts[pos] = val;
        updateVisibleValue(pos, val);
        syncCTAs();
      });
    });

    /* Dropdown change: select variant for non-color option */
    root.querySelectorAll('[data-md-simple-select]').forEach((sel) => {
      sel.addEventListener('change', () => {
        const pos = parseInt(sel.dataset.optionPosition, 10);
        const val = sel.value;
        if (!pos || !val) return;
        selectedOpts[pos] = val;
        updateVisibleValue(pos, val);
        syncCTAs();
      });
    });

    /* Open cart drawer (Paws / Horizon native / legacy fallback) */
    async function openCart(addData) {
      try {
        ['cart:add', 'cart:added', 'cart-add', 'cartadd'].forEach((name) => {
          try {
            document.dispatchEvent(new CustomEvent(name, {
              detail: { data: addData, source: 'md-pdp-simple' },
              bubbles: true,
            }));
          } catch (e) { /* ignore */ }
        });
      } catch (e) { /* ignore */ }

      try {
        if (typeof window.PAWS_CART_OPEN === 'function') { window.PAWS_CART_OPEN(); return true; }
      } catch (e) { /* ignore */ }

      try {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
      } catch (e) { /* ignore */ }

      try {
        const legacy = document.querySelector('cart-drawer, #CartDrawer');
        if (legacy) {
          if (typeof legacy.open === 'function') { legacy.open(); return true; }
          if (typeof legacy.showModal === 'function') { legacy.showModal(); return true; }
          legacy.setAttribute('open', '');
          return true;
        }
      } catch (e) { /* ignore */ }

      return false;
    }

    async function addToCart(quantity) {
      if (!currentVariantId) return null;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: currentVariantId, quantity: quantity || 1 }] }),
      });
      if (!res.ok) throw new Error('cart_add_failed');
      return res.json();
    }

    /* CTA: Agregar al carrito */
    const addBtn = root.querySelector('[data-md-simple-add]');
    if (addBtn) {
      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const original = addBtn.querySelector('.md-simple__cta-text');
        const originalText = original ? original.textContent : '';
        addBtn.disabled = true;
        if (original) original.textContent = 'Agregando…';
        try {
          const data = await addToCart(1);
          await openCart(data);
        } catch (err) {
          console.error('[md-pdp-simple] add error:', err);
          alert('No se pudo agregar al carrito. Intenta nuevamente.');
        } finally {
          addBtn.disabled = false;
          if (original) original.textContent = originalText;
        }
      });
    }

    /* CTA: Comprar ahora */
    const buyBtn = root.querySelector('[data-md-simple-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        buyBtn.disabled = true;
        try {
          await addToCart(1);
          window.location.href = '/checkout';
        } catch (err) {
          console.error('[md-pdp-simple] buy error:', err);
          alert('No se pudo procesar la compra. Intenta nuevamente.');
          buyBtn.disabled = false;
        }
      });
    }

    /* Sync visible labels with selectedOpts (in case they differ from option.selected_value) */
    Object.keys(selectedOpts).forEach((pos) => {
      updateVisibleValue(parseInt(pos, 10), selectedOpts[pos]);
    });
    /* Sync swatch "is-selected" state with actual selectedOpts (in case defaultV differs) */
    root.querySelectorAll('[data-md-simple-swatch]').forEach((sw) => {
      const pos = parseInt(sw.dataset.optionPosition, 10);
      const val = sw.dataset.value;
      const isSel = selectedOpts[pos] === val;
      sw.classList.toggle('is-selected', isSel);
      sw.setAttribute('aria-checked', isSel ? 'true' : 'false');
    });

    /* initial sync */
    syncCTAs();
  }

  function initAll() {
    document.querySelectorAll('[data-md-simple]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
